import React from 'react';
import { convertToNextImageUrl } from 'lib/updateImagePaths';
import { Header2 } from 'components/typography';

type MultiPhotoSlideWithTextProps = {
    index?: string | number;
    mediaURL?: string;
    title?: string;
    text?: string;
    name?: string;
    pronouns?: string;
};

function MultiPhotoSlideWithText(props: MultiPhotoSlideWithTextProps) {
    return (
        <li className="glide__slide" data-key={props.index} key={props.index}>
            <div className="center-align post-description">
                <div className="flex h-center highlight-slide">
                    <div className="w-2/5 spotlight-img md:hide">
                        <img src={`${convertToNextImageUrl(props.mediaURL)})`} alt="" />
                    </div>
                    <div className="w-3/5 md:w-1/1 left-align highlight-about">
                        <div className="highlight-m-header">
                            <img
                                className="lg:hide"
                                src={`${convertToNextImageUrl(props.mediaURL)}`}
                                alt=""
                            />

                            <div className="flex v-baseline highlight-name">
                                <Header2
                                    html={`<span class='white weight-medium"'>${props.name}</span>`}
                                />
                                <p className="yellow">{props.pronouns}</p>
                            </div>
                        </div>
                        <p className="white highlight-q">
                            <i>{props.title}</i>
                        </p>
                        <p className="white highlight-a">{props.text}</p>
                    </div>
                </div>
            </div>
        </li>
    );
}

export { MultiPhotoSlideWithText };
